import type { SettlementRepository } from '../repository/SettlementRepository';
import type { CommissionSumRequest, CommissionSumResponse } from '../entity/SettlementTypes';

export class GetCommissionSumUseCase {
  constructor(private readonly repository: SettlementRepository) {}

  async execute(request: CommissionSumRequest): Promise<CommissionSumResponse> {
    if (!request.params || request.params.length === 0) {
      throw new Error('검색 파라미터가 필요합니다.');
    }
    if (!request.local_field) {
      throw new Error('local_field가 필요합니다.');
    }
    if (!request.from) {
      throw new Error('from이 필요합니다.');
    }
    return this.repository.getCommissionSum(request);
  }
}

